import React from 'react';

function Error(props) {
    return (
        <div>
            error
        </div>
    );
}

export default Error;